import { render, staticRenderFns } from "./covid19.vue?vue&type=template&id=111fb3e2&scoped=true&"
import script from "./covid19.vue?vue&type=script&lang=js&"
export * from "./covid19.vue?vue&type=script&lang=js&"
import style0 from "./covid19.vue?vue&type=style&index=0&id=111fb3e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111fb3e2",
  null
  
)

export default component.exports